import React from "react";
import Modal from "../../components/Modal";

const Loading = (props: LoadingProps) => {
  return (
    <Modal isOpen={props.isLoading} className="loading" overlayClassName="loadingDim">
    </Modal>
  );
}

export default Loading;